import(/* webpackMode: "eager" */ "/home/runner/work/personal-website/personal-website/app/(tools)/tools/json-formatter/page.tsx");
